<template>
    <div>
        <Backer />
        <div class="fm-container">
            <b-alert show style="padding:5px; margin: 0px;">
                <div><b>{{ data.product_name || 'Create New Product Group' }}</b></div>
            </b-alert>

            <b-card>
                <div><b>Info</b></div>
                <div>
                    <span style="display: inline-block; margin: 10px; width: 400px;">
                        <b-card-text>
                            <div>Name:</div> <b-input required v-model="data.product_name" size="sm"></b-input>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px; width: 400px;">
                        <b-card-text>
                            <div>SKU:</div> <b-input required v-model="data.sku" size="sm"></b-input>
                        </b-card-text>
                    </span>
            

                    <span style="display: inline-block; margin: 10px; width: 200px;">
                        <b-card-text>
                            <div>Vendor:</div>
                            <b-form-select
                                v-model="data.vendor_id"
                                :options="vendors" 
                                size="sm" 
                            ></b-form-select>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px; width: 200px;">
                        <b-card-text>
                            <div>Category:</div>
                            <b-form-select
                                v-model="data.category_id"
                                :options="categories"
                                size="sm"
                            ></b-form-select>
                        </b-card-text>
                    </span>
                    
                    <span style="display: inline-block; margin: 10px; width: 100px;">
                        <b-card-text>
                            <div>Selling Price:</div>
                            <b-input v-model="data.selling_price" type="number" size="sm"></b-input>
                        </b-card-text>
                    </span>

                    <span style="display: inline-block; margin: 10px;">
                        <b-card-text>
                            <div>Active Status:</div>
                            <b-form-select
                                v-model="data.status"
                                :options="statuses"
                                size="sm"
                            ></b-form-select>
                        </b-card-text>
                    </span>
                </div>
            

                <div>
                    <div><b>Children</b></div>
                    <div>
                        <vue-good-table
                          s
                          :columns="children_columns"
                          @on-cell-click="onChildrenColumnClick"
                          :rows="data.children"
                          :pagination-options="{
                            enabled: false,
                            mode: 'pages',
                            position: 'top',
                            perPage: 20
                          }"
                          :search-options="{
                            enabled: false,
                            trigger: 'enter'
                          }"
                          :select-options="{ enabled: false }"
                          styleClass="vgt-table bordered "
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <span>
                                        <b-button variant="outline-danger" size="sm">Remove</b-button>
                                        <b-button variant="outline-primary" size="sm" style="visibility: hidden;"> </b-button>
                                    </span>
                                </span>

                                <span v-else-if="props.column.field == 'quantity'">
                                    <b-input size="sm" style="margin: auto; width: 100px; background: #efefff; text-align: center;" v-model="data.children[props.row.originalIndex].quantity" type="number" min="1"></b-input>
                                </span>

                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>

                    <div style="padding: 10px; text-align: center;">
                        <b-button size="md" variant="primary" @click="saveProductGroup" :disabled="block_submit">Save</b-button>
                    </div>
                </div>
            </b-card>

            <b-alert show>
                <div>
                    <b-button v-b-toggle.add-new-children variant="secondary" size="sm">
                        Add new children
                    </b-button>
                </div>
                <b-collapse id="add-new-children">
                    <b-card>
                        <div style="margin-bottom: 10px;">
                            <span style="display: inline-block;">
                                <b-input size="sm" style="width: 500px;" v-model="search_keyword" placeholder="search a product / sku"></b-input>
                            </span>
                            <span style="display: inline-block;">
                                <b-button size="sm" variant="success" :disabled="block_search" @click="searchChildren">Search</b-button>
                            </span>
                        </div>

                        <vue-good-table
                          v-show="searched_children.length > 0"
                          :columns="searched_children_columns"
                          @on-cell-click="onSearchedChildrenColumnClick"
                          :rows="searched_children"
                          :pagination-options="{
                            enabled: false,
                            mode: 'pages',
                            position: 'top',
                            perPage: 20
                          }"
                          :search-options="{
                            enabled: false,
                            trigger: 'enter'
                          }"
                          :select-options="{ enabled: false }"
                          styleClass="vgt-table bordered condensed"
                        >
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <span>
                                        <b-button variant="outline-success" size="sm">Add</b-button>
                                        <b-button variant="outline-primary" size="sm" style="visibility: hidden;"> </b-button>
                                    </span>
                                </span>

                                <span v-else-if="props.column.field == 'quantity'">
                                    <b-input size="sm" style="margin: auto; width: 100px;" v-model="searched_children[props.row.originalIndex].quantity" type="number"></b-input>
                                </span>

                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>
                            </template>
                        </vue-good-table>
                    </b-card>
                </b-collapse>
            </b-alert>
        </div>
    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "AddProductGroup",
        props: [],
        components: {Backer,Multiselect,VueGoodTable},
        data: function(){
            return {
                userDetails: {},
                data: {
                    product_name: null,
                    sku: null,
                    vendor_id: null,
                    category_id: null,
                    selling_price: 0.0,
                    status: "active",
                    children: []
                },
                categories: [],
                vendors: [],
                statuses: [
                    {value: "active", text: "ACTIVE"},
                    {value: "discontinued", text: "DISCONT."},
                ],
                children_columns: [
                    {
                        label: "ID",
                        field: "child_product_id",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Name",
                        field: "child_product_name",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "SKU",
                        field: "child_product_sku",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Quantity",
                        field: "quantity",
                        filterable: false,
                        sortable: false,
                    },
                    
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                ],
                block_search: false,
                block_submit: false,
                searched_children: [],
                searched_children_columns: [
                    {
                        label: "ID",
                        field: "id",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Name",
                        field: "product_name",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "SKU",
                        field: "sku",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "S Price",
                        field: "selling_price",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Quantity",
                        field: "quantity",
                        filterable: false,
                        sortable: false,
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                ],
                search_keyword: null,
            }
        },
        methods: {
            onChildrenColumnClick: function(params){
                let action = params.event.target.innerText;
                if (action === "Remove") {
                    this.removeFromChildren(params.row);
                }
            },
            onSearchedChildrenColumnClick: function(params){
                let action = params.event.target.innerText;
                if (action === "Add") {
                    this.addToChildren(params.row);
                }
            },
            removeFromChildren: function(product){
                let filtered = this.data.children.filter(function(d){
                    return d.child_product_id != product.child_product_id;
                });
                this.data.children = filtered;
            },
            addToChildren: function(product){
                let id = product.id;
                let exists = this.data.children.filter(function(d){
                    return d.child_product_id == id;
                });

                if (exists.length > 0){
                    this.$bvToast.toast(
                        "Child already exists.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                if (parseFloat(product.quantity) <= 0 || isNaN(parseFloat(product.quantity)) || product.quantity == null || isNaN(product.quantity)) {
                    this.$bvToast.toast(
                        "Cannot add a child with <= 0 quantity", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    return
                }

                let child = {
                    child_product_id: product.id,
                    child_product_name: product.product_name,
                    child_product_sku: product.sku,
                    quantity: parseFloat(product.quantity)
                }
                this.data.children.push(child);
            },
            searchChildren: function(e){
                if (e){
                    e.preventDefault();
                }
                if (!this.search_keyword || this.search_keyword.length < 2){
                    this.$bvToast.toast(
                        "Please search with a more specific keyword", 
                        {title: "Incomplete Search", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                let that = this;
                let path = "/api/product/search_child_products/"
                let data = {keyword: this.search_keyword}

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else{

                        that.searched_children = response.data.result;
                        if (that.searched_children.length == 0){
                            that.$bvToast.toast(
                                "No products found matching keyword: '"+that.search_keyword+"'", 
                                {title: "No result", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                    that.block_search=false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "An error occurred. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.block_search=false;
                }
                this.block_search = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            validate: function(product_group){
                let errors=[];
                if (product_group.product_name == null || product_group.product_name.length < 3){
                    errors.push("Invalid product group name");
                }
                if (product_group.sku == null || product_group.sku.length < 3){
                    errors.push("Invalid product group sku");
                }
                if (product_group.category_id == null){
                    errors.push("Please pick a category");
                }
                if (product_group.vendor_id == null){
                    errors.push("Please pick a vendor");
                }
                if (product_group.children.length <= 0){
                    errors.push("Please add at least one child");
                }
                return errors;
            },
            saveProductGroup: function(e){
                if (e){
                    e.preventDefault();
                }
                let product_group = this.data;
                let errors = this.validate(product_group);
                if (errors.length > 0){
                    this.$bvToast.toast(
                        errors[0], 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }
                let that = this;
                let path = "/api/product/add_product_group/"
                let data = {product: product_group}
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Added product group.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.reset();
                    }
                    that.block_submit = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Cannot add a product group. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.block_submit = false;
                }
                this.block_submit = true;
                Requestor.postSyncP(path, data, this, s, f);

            },
            reset: function(e){
                if (e){
                    e.preventDefault();
                }
                this.data = {
                    product_name: null,
                    sku: null,
                    vendor_id: null,
                    category_id: null,
                    selling_price: 0.0,
                    status: "active",
                    children: []
                };
                this.searched_children = [];
                this.search_keyword = null;

            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/product/category/all/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response){
                            if (response.data.result){
                                that.categories = response.data.result.map(function(d){
                                    return {value: d[0], text: d[1]}
                                });

                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading categories.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/vendor/all/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response){
                            if (response.data.result){
                                that.vendors = response.data.result.map(function(d){
                                    return {value: d[0], text: d[1]}
                                });
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading vendors list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);    
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                console.log(this.userDetails);
                if (this.userDetails.userrole == "admin"){
                    this.fetch_prereqs();
                }
                else {
                    this.$router.replace({"path":  "/"})
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/AddProductGroup.vue